import React, { Component } from 'react';
import Big from 'big.js';
import { connect } from 'react-redux';

class DiscountModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }


  render() {
    const {
      toggleModal,
      variablePricing,
      vPricingDiscount,
      vOGTicker,
      vSpend,
      useSpend,
      humA,
      humB,
      isOfType,
      tradeType,
    } = this.props;

    let discountType = 'Discount';
    if (tradeType === 'SELL') {
      discountType = 'Bonus';
    }

    let pricingCriteria;
    if (variablePricing && variablePricing.pricingCriteria) {
      pricingCriteria = variablePricing.pricingCriteria;
    }

    let volumeRange;
    if (variablePricing && variablePricing.pricingVolume) {
      volumeRange = variablePricing.pricingVolume;
    }
    let volumeHigh;
    if (volumeRange && volumeRange.high) {
      volumeHigh = volumeRange.high;
    }
    let volumeLow;
    if (volumeRange && volumeRange.low) {
      volumeLow = volumeRange.low;
    }


    let timeRange;
    if (variablePricing && variablePricing.timeRange) {
      timeRange = variablePricing.timeRange;
    }
    let timeStart = '0';
    if (timeRange && timeRange.startTime) {
      timeStart = timeRange.startTime;
    }
    let formattedTimeStart;
    if (timeStart) {
      if ((timeStart >= 0) && (timeStart <= 9)) {
        formattedTimeStart = '0' + timeStart.toString() + ':00';
      }
      if (timeStart > 9) {
        formattedTimeStart = timeStart.toString() + ':00';
      }
    }
    let timeEnd = '0';
    if (timeRange && timeRange.endTime) {
      timeEnd = timeRange.endTime;
    }
    let formattedTimeEnd;
    if (timeEnd) {
      if ((timeEnd >= 0) && (timeEnd <= 9)) {
        formattedTimeEnd = '0' + timeEnd.toString() + ':00';
      }
      if (timeEnd > 9) {
        formattedTimeEnd = timeEnd.toString() + ':00';
      }
    }
    let timeDays = {};

    if (timeRange && timeRange.daysApplicable) {
      timeDays = timeRange.daysApplicable;
    }

    let availableDays = [];

    Object.keys(timeDays).forEach((key) => {
      if (timeDays[key] === true) {
        availableDays.push(key);
      }
    });

    const availableDaysLoop = availableDays && availableDays.length && availableDays.map((item, index) => {
      return (
        <span key={index}>
          {item}
          {index === (availableDays.length - 1) ? (null) : (
            <>
              ,&nbsp;
            </>
          )} 
        </span>
      );
    });

    let saveAmount;
    if ((vSpend >= 0 ) && (useSpend >= 0)) {
      saveAmount = useSpend.minus(vSpend).abs();
    }
    let useAmount;
    if (saveAmount) {
      useAmount = saveAmount.abs();
    }

    let nextDiscount = {};
    if (variablePricing && variablePricing.nextDiscount) {
      if (Object.keys(variablePricing.nextDiscount).length) {
        nextDiscount = variablePricing.nextDiscount;
      }
    }
    let nextPricingCriteria;
    let nextPricingDiscount;
    let nextPricingVolume;
    if (nextDiscount && Object.keys(nextDiscount).length) {
      if (nextDiscount.pricingCriteria) {
        nextPricingCriteria = nextDiscount.pricingCriteria;
      }
      if (nextDiscount.pricingDiscount) {
        nextPricingDiscount = nextDiscount.pricingDiscount;
      }
      if (nextDiscount.pricingVolume) {
        nextPricingVolume = nextDiscount.pricingVolume;
      }
    }

    let savedAsset = humB;
    let volumeAsset = humA;

    if (tradeType === 'BUY') {
      savedAsset = humB;
      volumeAsset = humA;
    }
    if (tradeType === 'SELL') {
      savedAsset = humA;
      volumeAsset = humB;
    }

    return (
      <div className="modal-content">
        <div className="modal-heading">
          {discountType} Details
        </div>
        <div className="modal-body">
          <p>
            Congrats! We&apos;ll apply this {discountType} to your order once you&apos;ve confirmed it.
          </p>
          <div className="modal-quote">
            <div className="lr-p">
              <p>{discountType} Percentage:&nbsp;
                <b>
                  {vPricingDiscount ? (vPricingDiscount + '%') : ('--')}
                </b>
              </p>
              <p>Total {discountType}:&nbsp;
                <b>
                  {saveAmount ? (saveAmount.toFixed(8)) : ('--')}
                  {isOfType(savedAsset, 'METAL') ? (
                    'g'
                  ) : ('')}
                  {isOfType(savedAsset, 'CRYPTO') ? (
                    ' ' + savedAsset.toUpperCase()
                  ) : ('')}
                </b>
              </p>
            </div>
            <div className="lr-p">
              <p>{discountType} Type: <b style={{textTransform: 'uppercase'}}>{pricingCriteria.toLowerCase()}</b></p>
              { pricingCriteria === 'VOLUME' ? (
                <p>Volume Range:&nbsp;
                  <b>
                    {volumeLow ? (
                      <>
                        {volumeLow}
                        {isOfType(volumeAsset, 'METAL') ? (
                          'g'
                        ) : ('')}
                      </>
                    ) : ('--')}
                    &nbsp;-&nbsp;
                    {volumeHigh ? (
                      <>
                        {volumeHigh}
                        {isOfType(volumeAsset, 'METAL') ? (
                          'g'
                        ) : ('')}
                      </>
                    ) : ('--')}
                    &nbsp;
                    {volumeAsset.toUpperCase()}
                  </b>
                </p>
              ) : (null) }
              { pricingCriteria === 'TIME' ? (
                <p>Time Available:&nbsp;
                <b>
                  {formattedTimeStart ? (formattedTimeStart) : ('--')}
                  &nbsp;-&nbsp;
                  {formattedTimeEnd ? (formattedTimeEnd) : ('--')}
                </b>
              </p>
              ) : (null) }
            </div>
            { pricingCriteria === 'TIME' ? (
              <div>
                <p>Days Available:&nbsp;
                  <b style={{textTransform: 'capitalize'}}>
                    {availableDaysLoop}
                  </b>
                </p>
              </div>            
            ) : (null)}
            {nextPricingCriteria === 'VOLUME' ? (
              <>
                <hr/>
                <div className="text-center">
                  <p>
                    <b>Want a Bigger {discountType}?</b>
                  </p>
                  <p>
                    If you&nbsp;
                    {tradeType === 'BUY' ? (
                      'order '
                    ) : (
                      'trade '
                    )}
                    <b>
                      {nextPricingVolume ? (
                        <>
                          {nextPricingVolume}
                          {isOfType(volumeAsset, 'METAL') ? (
                            'g'
                          ) : ('')}
                        </>
                      ) : ('--')}
                      &nbsp;{volumeAsset.toUpperCase()}
                    </b>
                    &nbsp;you&apos;ll get a&nbsp;
                    <b>
                      {nextPricingDiscount ? (
                        nextPricingDiscount + '%'
                      ) : '--%'}
                    </b>
                    &nbsp;{discountType} instead!
                  </p>
                </div>
              </>
            ) : (null)}
          </div>
        </div>
        <div className="cell small-12 medium-12 large-12 modal-actions">
          <button className="button" type="button" onClick={() => toggleModal()}>
            <span>
              Close
            </span>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  success: state.user.success,
  orders: state.order,
  quote: state.order.quote,
});

export default connect(mapStateToProps)(DiscountModal);
